import { render, staticRenderFns } from "./albaran_proveedor.vue?vue&type=template&id=58fde23f&"
import script from "./albaran_proveedor.vue?vue&type=script&lang=js&"
export * from "./albaran_proveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports